import { AreaComumValor } from "core/features/reservas/typings/index";
import { Destino } from "core/features/mensagens/typings";
import { AreaComumDia, FormaValorTaxa } from "../enums";

export interface AreaComumResponse {
  id: string;
  nome: string;
  capacidadeMaxima: number | null;
  valor: number | null;
  valorMinimo: number | null;
  valorMaximo: number | null;
  ativo: boolean;
  tipoAreaComum?: string;
}

export interface AreaComumForm extends AreaComumResponse {
  termoUso: string;
  tipoAreaComumId: string;
  categoriaFinanceiraId: string;
  confirmacaoAutomatica: boolean;

  imagens: { url: string; id: string }[];
  valores: AreaComumValor[];
}

export interface BloqueioAntesDepoisReservaItem {
  tipoIntervaloPeriodoAntes: TipoIntervaloPeriodo | null;
  periodoAntes: number | null;
  tipoIntervaloPeriodoDepois: TipoIntervaloPeriodo | null;
  periodoDepois: number | null;
  diaSemana: DiaSemanaNumero | null;
}
export interface AreaComumRegrasReserva {
  realizarReservaAntesUtilizarOutra: boolean;
  inadimplentePodeReservar: boolean;
  duracaoReserva: number;
  diasVencimentoCobranca: number;
  maximoAntecendencia: number;
  minimoAntecendencia: number;
  intervaloEntreReserva: number;
  antecedenciaCancelarReserva: number;

  tipoIntervaloEntreReserva: TipoIntervaloPeriodo;
  tipoIntervaloDuracaoReserva: TipoIntervaloPeriodo;
  tipoIntervaloAntecedenciaCancelarReserva: TipoIntervaloPeriodo;
  tipoIntervaloMaximoAntecendencia: TipoIntervaloPeriodo;
  tipoIntervaloMinimoAntecendencia: TipoIntervaloPeriodo;
  tipoVencimentoCobranca: AreaComumTipoVencimentoCobrancaEnum;

  bloqueioAntesDepoisReserva: BloqueioAntesDepoisReservaItem[];

  limitesReservaPeriodo: LimitesReservaPeriodo[];
}

export interface LimitesReservaPeriodo {
  id?: string;
  added?: boolean;
  tempId?: string;
  limite: number | undefined;
  tipoIntervaloPeriodoLimite: TipoIntervaloPeriodo | undefined;
}

export interface ParametrosAreaComum {
  diaVencimento: number;
  bloquearInadimplente: boolean;
  realizarReservaAntesUtilizarOutra: boolean;
  maximoReservaUnidadeMes: number;
  cancelamentoAutomatico: boolean;
  diasCancelamentoAutomatico: number | null;
}

export enum TipoIntervaloPeriodo {
  Minuto = "minuto",
  Hora = "hora",
  Dia = "dia",
  Semana = "semana",
  Mes = "mes",
  Trimestre = "trimestre",
  Semestre = "semestre",
  Ano = "ano",
}

export enum AreaComumTipoVencimentoCobrancaEnum {
  DiaCriacaoReserva = "dia-criacao-reserva",
  DiaDoEvento = "dia-evento",
}

export enum DiaSemanaNumero {
  Domingo = 0,
  Segunda = 1,
  Terca = 2,
  Quarta = 3,
  Quinta = 4,
  Sexta = 5,
  Sabado = 6,
}

export enum AreaComumDiaStatus {
  Livre = "livre",
  Parcialmente = "parcialmente",
  Ocupado = "ocupado",
  Bloqueado = "bloqueado",
}

export interface AreaComumHorario {
  data: string;
  horarios: AreaComumHorarioItem[];
  status: AreaComumDiaStatus;
  motivo?: string;
}
export interface AreaComumHorarioItem {
  inicio: string;
  fim: string;
  status: AreaComumDiaStatus;
  motivo?: string;
}

export interface AreaComumDisponibilidadeResponse {
  items: AreaComumDisponibilidadeItem[];

  duracaoReserva: number | null;
  maximoAntecendencia: number | null;
  minimoAntecendencia: number | null;
  intervaloEntreReserva: number | null;

  tipoIntervaloEntreReserva: TipoIntervaloPeriodo | null;
  tipoIntervaloDuracaoReserva: TipoIntervaloPeriodo | null;
  tipoIntervaloMaximoAntecendencia: TipoIntervaloPeriodo | null;
  tipoIntervaloMinimoAntecendencia: TipoIntervaloPeriodo | null;
  realizarReservaAntesUtilizarOutra: boolean;
}

export interface AreaComumDiaHoraItem {
  horaInicio?: string;
  horaFim?: string;
  dia: number;
}

export interface AreaComumDisponibilidadeItem extends AreaComumDiaHoraItem {
  intervaloHoraInicio?: string;
  intervaloHoraFim?: string;
}
export interface AreaComumBloqueioDataItem {
  id?: string | number;
  dataInicio: string | null;
  dataFim?: string;
  motivo?: string;
  items: AreaComumBloqueioDataDiaItem[];
}

export interface AreaComumBloqueioDataDiaItem extends AreaComumDiaHoraItem {}

export interface AreaComumTaxasForm {
  id?: string;
  ehPago?: "1" | "0";
  cobrarNaTaxaCondominial: "1" | "0";
  valor?: number;
  categoriaFinanceiraId?: string;
  tenantContaId?: string;
  formaValorTaxaAreaComumId: FormaValorTaxa;
  valores: AreaComumTaxasValor[];
  formasPagamento: string[];
}

export interface AreaComumTaxasValor {
  criterioValor: AreaComumDia | null;
  valor: string | null;
}

export interface AreaComumUnidadeBloqueadaItem {
  id: string;
  dataFim: string;
  dataInicio: string;
  motivo?: string;
  usuarioOperador: {
    nome: string;
  };
}

export interface AreaComumUnidadeBloqueioForm {
  id?: string;
  destinos: Destino[];
  dataInicio: string;
  dataFim: string;
  diasBloqueio?: number;
  tipoDestinoId: string;
  motivo?: string;
}

export interface AreaComumUnidadeBloqueadaDetalhe
  extends AreaComumUnidadeBloqueioForm {
  id: string;
}
export interface VinculoAreaComum {
  id: string;
  nome: string;
}
